module.exports = __webpack_public_path__ + "static/img/news_xwdt_banner.bee28ef.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/news_xwdt_banner.png
// module id = 5+jx
// module chunks = 0